<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：首页-留言板</div>
      </div>
      <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="nav-titie">
          留言板
          <div class="list-box">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="sidebar"
              :class="{ active: selectedItem === item }"
              @click="selectItem(item)"
            >
              {{ item }}
            </div>
            <img src="../../../assets/images/nav-img.png" alt="" />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="box">
          <div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="姓    名：" prop="name">
                <el-input
                  placeholder="请输入"
                  v-model="ruleForm.name"
                  style="width: 340px; height: 36px"
                ></el-input>
              </el-form-item>
              <el-form-item label="单位：" prop="unit">
                <el-input
                  placeholder="请输入"
                  v-model="ruleForm.company"
                  style="width: 340px; height: 36px"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式：" prop="phone">
                <el-input
                  placeholder="请输入"
                  v-model="ruleForm.phone"
                  style="width: 340px; height: 36px"
                ></el-input>
              </el-form-item>
              <el-form-item label="标题：" prop="title">
                <el-input
                  placeholder="请输入"
                  v-model="ruleForm.title"
                  style="width: 340px; height: 36px"
                ></el-input>
              </el-form-item>
              <el-form-item label="内容：" prop="content">
                <el-input
                  type="textarea"
                  placeholder="请输入"
                  v-model="ruleForm.content"
                  class="custom-textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="附件：">
                <el-upload
                  :action="actionUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-success="handleFileSuccess"
                  :file-list="fileList"
                  :headers="headers"
                  :limit="4"
                  :on-exceed="handleExceed"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
              </el-form-item>
              <el-form-item label="文件：" prop="file">
                <el-upload
                  :action="actionUrl"
                  accept=".pdf,.pdfa,.epub"
                  :on-remove="documenthandleRemove"
                  :on-success="documenthandleFileSuccess"
                  :file-list="documentfileList"
                  :headers="headers"
                  :limit="10"
                  :on-exceed="documenthandleExceed"
                >
                  <el-button type="primary">上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="说明：" class="explain">
                <span>带*号是必填项</span>
              </el-form-item>
            </el-form>
            <div style="text-align: center">
              <el-button class="submit" @click="submitForm('ruleForm')"
                >提交</el-button
              >
              <el-button class="submit" @click="returnshow()"
                >关闭</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { addboard } from "@/api/index";
export default {
  data() {
    return {
      dialogImageUrl:'',
      dialogVisible:false,
      actionUrl: "http://59.203.187.199:8199" + "/common/upload",
      headers: { Authorization: "Bearer " },
      fileList: [],
      documentfileList: [],
      list: ["火焰蓝热线"],
      selectedItem: "火焰蓝热线",
      fileName: "",
      fileNameSec: "",
      ruleForm: {
        title: "",
        content: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [
          { required: true, message: "请填写内容", trigger: "blur" },
        ],
      },
      type:0,
    };
  },
  // mounted() {
  //     this.initMap()
  // },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
      this.fileList = [];
      this.documentfileList = [];
      this.ruleForm = {};
      console.log(this.selectedItem);
      if (this.selectedItem === '火焰蓝热线') {
        this.type = 0
      }else {
        this.type = 1
      }
      console.log(this.type);
      
    },
    returnshow() {
      this.$emit("setCilck");
    },
    submitForm(formName) {
      this.ruleForm.type = this.type; 
      let arr = [];
      if (this.fileList) {
        this.fileList.forEach((item) => {
          arr.push(item.url);
        });
      }
      let arr2 = [];
      if (this.documentfileList) {
        this.documentfileList.forEach((item) => {
          arr2.push(item.url);
        });
      }
      this.ruleForm.annexUrl1 = arr.join(",");
      this.ruleForm.annexUrl2 = arr2.join(",");
      console.log(this.ruleForm, "ruleForm");

      this.$refs[formName].validate((valid) => {
        if (valid) {
          addboard(this.ruleForm).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      this.fileList = [];
      this.documentfileList = [];
      this.ruleForm = {};
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 图片上传
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file) {
      this.fileList.forEach((item, index) => {
        if (file.url == item.url) {
          this.fileList.splice(index, 1);
        }
      });
    },
    // 在这里执行上传文件成功的逻辑
    handleFileSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.fileList.push({
          name: response.originalFilename,
          url: response.url,
        });
      }
      console.log(this.fileList);
    },
    // 在这里执行超出文件数量的逻辑
    handleExceed() {
      this.$message.warning("最多只能上传十个文件");
    },
    // 文件上传
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    documenthandleRemove(file) {
      this.documentfileList.forEach((item, index) => {
        if (file.url == item.url) {
          this.documentfileList.splice(index, 1);
        }
      });
    },
    // 在这里执行上传文件成功的逻辑
    documenthandleFileSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.documentfileList.push({
          name: response.originalFilename,
          url: response.url,
        });
      }
      console.log(this.documentfileList);
    },
    // 在这里执行超出文件数量的逻辑
    documenthandleExceed() {
      this.$message.warning("最多只能上传十个文件");
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #f0f5ff;
}

.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
.content {
  width: 980px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .left {
    .nav-titie {
      position: relative;
      width: 180px;
      height: 236px;
      background: #0e67ab;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      padding: 12px;
      box-sizing: border-box;

      .list-box {
        position: absolute;
        top: 53px;
        left: 12px;
        width: 169px;
        background-color: #fff;

        .sidebar {
          width: 168px;
          height: 56px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          line-height: 56px;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .sidebar.active {
          background-color: #d4ac62;
          color: #fff;
        }

        img {
          width: 168px;
          height: 100px;
          margin-top: 16px;
        }
      }
    }
  }

  .right {
    width: 816px;
    min-height: 800px;
    background: #ffffff;
    border: 1px solid #d6d8d7;
    padding: 30px 60px 0 60px;
    margin-left: 1px;
    .box {
      width: 840px;
      height: 633px;
      .el-form-item {
        margin-bottom: 18px;
      }
      // padding: 40px 60px 0 60px;
      // .upload-btn {
      //     display: none;
      // }
      .custom-file-upload {
        width: 80px;
        height: 36px;
        background: linear-gradient(180deg, #ffffff 0%, #eeeeee 100%);
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        border: 1px solid #e3e9ee;
      }
      .explain {
        color: #999999;
        .el-form-item__label {
          color: #999999;
        }
      }
      .submit {
        width: 74px;
        height: 36px;
        background: linear-gradient(180deg, #ffffff 0%, #eeeeee 100%);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #e3e9ee;
      }
    }

    .custom-textarea {
      width: 500px;
    }

    .custom-textarea ::v-deep .el-textarea__inner {
      height: 160px;
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
</style>
